// extracted by mini-css-extract-plugin
module.exports = {"container":"Landing_container__30RXb","home":"Landing_home__1OLa-"};